// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../react-forms/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../react-forms/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.passkey-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 24px;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    width: 100%;
}

.passkey-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.passkey-button-primary {
    background-color: #4CAF50;
    color: white;
}

.passkey-button-primary:hover:not(:disabled) {
    background-color: #45a049;
}

.passkey-button-secondary {
    background-color: #f5f5f5;
    color: #333;
    border: 1px solid #ddd;
}

.passkey-button-secondary:hover:not(:disabled) {
    background-color: #e0e0e0;
}

.passkey-icon {
    flex-shrink: 0;
}

.passkey-button-loading {
    display: flex;
    align-items: center;
    gap: 8px;
}

.spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-top-color: white;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

.passkey-button-secondary .spinner {
    border-color: rgba(0, 0, 0, 0.2);
    border-top-color: #333;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}`, "",{"version":3,"sources":["webpack://./../public/css/passkey-button.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,uBAAuB;IACvB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ","sourcesContent":[".passkey-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 12px 24px;\n    border: none;\n    border-radius: 4px;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    width: 100%;\n}\n\n.passkey-button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n.passkey-button-primary {\n    background-color: #4CAF50;\n    color: white;\n}\n\n.passkey-button-primary:hover:not(:disabled) {\n    background-color: #45a049;\n}\n\n.passkey-button-secondary {\n    background-color: #f5f5f5;\n    color: #333;\n    border: 1px solid #ddd;\n}\n\n.passkey-button-secondary:hover:not(:disabled) {\n    background-color: #e0e0e0;\n}\n\n.passkey-icon {\n    flex-shrink: 0;\n}\n\n.passkey-button-loading {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.spinner {\n    width: 16px;\n    height: 16px;\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-top-color: white;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n}\n\n.passkey-button-secondary .spinner {\n    border-color: rgba(0, 0, 0, 0.2);\n    border-top-color: #333;\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
